module.exports = __webpack_public_path__ + "site/img/120.9660d357.jpg";